import getOrderLineDosFrom1 from 'utils/print/getOrderLineDosFrom1';
import getOrderLineDosFrom2 from 'utils/print/getOrderLineDosFrom2';
import getOrderLineDosFrom3 from 'utils/print/getOrderLineDosFrom3';

const getOrderLineDosFrom = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const orderLineDosFrom1 = getOrderLineDosFrom1(otherProps);
  const orderLineDosFrom2 = getOrderLineDosFrom2(otherProps);
  const orderLineDosFrom3 = getOrderLineDosFrom3(otherProps);
  if (orderLineDosFrom1 && orderLineDosFrom2 && orderLineDosFrom3) {
    return `${orderLineDosFrom1}/${orderLineDosFrom2}/${orderLineDosFrom3}`;
  }

  return null;
};

export default getOrderLineDosFrom;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosFrom.js